/**
 * @author Vibhor <vibhor.sh@314ecorp.com>
 * @description Organization Settings Card
 */

import { Card, Flex, Typography } from 'antd';
import { CardProps } from 'antd/lib/card';

import { getSupportEmail } from 'components/widgets/DetailsRenderer';
import { useAppStoreValues } from 'store/app';

export interface IProps extends Omit<CardProps, 'title'> {
	children?: React.ReactNode;
}

const OrganizationSettingsCard: React.FC<IProps> = ({ children, ...props }) => {
	const { setupInfo } = useAppStoreValues();
	return (
		<Card
			{...props}
			title={
				<Flex vertical gap={4} style={{ padding: '10px 0' }}>
					<Typography.Title level={4} style={{ margin: 0, fontSize: 18 }}>
						{'Organization Settings'}
					</Typography.Title>
					<Typography.Text type='secondary'>
						{'For any organization setting changes, please reach out to our support team for assistance at'}
						{getSupportEmail({ email: setupInfo.supportEmail })}
					</Typography.Text>
				</Flex>
			}
		>
			{children}
		</Card>
	);
};

export default OrganizationSettingsCard;
